// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../../../public/SiteImages/fondo-ondulado-para-personaje.svg");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Feedback-space1-X4QlB {
	margin-bottom: 6px !important;
}

.Feedback-space2-ikHfX {
	margin-bottom: 12px !important;
}

.Feedback-space3-R4nNe {
	margin-bottom: 18px !important;
}

.Feedback-space4-RqXTZ {
	margin-bottom: 24px !important;
}

.Feedback-space5-mWZay {
	margin-bottom: 30px !important;
}

.Feedback-space6-iDXQD {
	margin-bottom: 36px !important;
}

.Feedback-space7-CPYYl {
	margin-bottom: 42px !important;
}

.Feedback-spaceTop8-GuA_r {
	margin-bottom: 48px !important;
}

.Feedback-spaceTop1-bdpfn {
	margin-top: 6px !important;
}

.Feedback-spaceTop2-laFS0 {
	margin-top: 12px !important;
}

.Feedback-spaceTop3-nQL5U {
	margin-top: 18px !important;
}

.Feedback-spaceTop4-MNUWU {
	margin-top: 24px !important;
}

.Feedback-spaceTop5-qY4ZT {
	margin-top: 30px !important;
}

.Feedback-spaceTop6-MJ8AC {
	margin-top: 36px !important;
}

.Feedback-spaceTop7-it3S1 {
	margin-top: 42px !important;
}

.Feedback-spaceTop8-GuA_r {
	margin-top: 48px !important;
}

.Feedback-noMargin-A5N02 {
	margin: 0px !important;
}

.Feedback-padding1-_CZfk {
	padding-bottom: 6px !important;
}

.Feedback-padding2-pzcs7 {
	padding-bottom: 12px !important;
}

.Feedback-padding3-cgY4R {
	padding-bottom: 18px !important;
}

.Feedback-padding4-AdLns {
	padding-bottom: 24px !important;
}

.Feedback-padding5-SoG33 {
	padding-bottom: 30px !important;
}

.Feedback-padding6-uuRob {
	padding-bottom: 36px !important;
}

.Feedback-padding7-SoGNE {
	padding-bottom: 42px !important;
}

.Feedback-paddingTop1-Qj0sU {
	padding-top: 6px !important;
}

.Feedback-paddingTop2-tz6OJ {
	padding-top: 12px !important;
}

.Feedback-paddingTop3-oljW9 {
	padding-top: 18px !important;
}

.Feedback-paddingTop4-OHoVp {
	padding-top: 24px !important;
}

.Feedback-paddingTop5-pgb3N {
	padding-top: 30px !important;
}

.Feedback-paddingTop6-j3xYT {
	padding-top: 36px !important;
}

.Feedback-paddingTop7-JQ3X9 {
	padding-top: 42px !important;
}

.Feedback-noPadding-EbPH9 {
	padding: 0px !important;
}

.Feedback-textBold-q1H4F {
	font-weight: 500 !important;
}

.Feedback-textBolder-sa70W {
	font-weight: 700 !important;
}

.Feedback-textNormal-Ee5A5 {
	font-weight: normal !important;
}

.Feedback-spaceBottom20-dS0Pv {
	margin-bottom: 20px;
}

.Feedback-spaceBottom10-VwjvL {
	margin-bottom: 10px;
}

.Feedback-marginNone-Xh6Gb {
	margin: 0;
}

.Feedback-spaceBottom15-hJ2qE {
	margin-bottom: 15px;
}

.Feedback-marginTopNone-rSvqD {
	margin-top: 0;
}

.Feedback-spaceTop11-N0t_r {
	margin-top: 11px;
}

.Feedback-spaceTop21-lJRtS {
	margin-top: 21px;
}

.Feedback-spaceTop20-E51Q1 {
	margin-top: 20px;
}

.Feedback-spaceTop10-YUUC9 {
	margin-top: 10px;
}

/*New Design Text Colors */

.Feedback-textDarkBlue-hodQA {
	color: rgb(20, 39, 94) !important;
}

.Feedback-textLightBlue-F_1Z3 {
	color: rgb(57, 87, 106) !important;
}

.Feedback-textLightSandleGreen-ChU2A {
	color: rgb(76, 86, 41) !important;
}

.Feedback-textLightBrown-M32ww {
	color: rgb(115, 79, 33) !important;
}

.Feedback-textMediumMaroon-Z0nQN {
	color: rgb(87, 37, 51) !important;
}

.Feedback-textBrown-WQghJ {
	color: rgb(160, 47, 24) !important;
}

.Feedback-textMaroon-k8lGw {
	color: rgb(155, 49, 67) !important;
}

.Feedback-textDarkBrown-tlbV2 {
	color: rgb(83, 18, 16) !important;
}

.Feedback-textMediumBrown-vKSc4 {
	color: rgb(142, 28, 10) !important;
}

.Feedback-textSkyBlue-l7Zb8 {
	color: rgb(37, 117, 141) !important;
}

.Feedback-textGray-CDalt {
	color: rgb(77, 65, 51) !important;
}

.Feedback-root-Zwdi4 {
	color: var(--primary-foreground);
	padding: 0px;
	width: 100%;
	position: relative;
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
	background-repeat: no-repeat;
	background-position: center top;
	background-size: 100% 100%;
	padding-top: clamp(60px, 6.5vw, 105px);
	padding-bottom: clamp(65px, 7.5vw, 120px);
	-webkit-box-sizing: border-box;
	        box-sizing: border-box;
}

.Feedback-container-ynCq4 {
	margin: 0 auto;
	width: 100%;
	/* max-width: 1578px; */
	display: block;
	-webkit-box-sizing: border-box;
	        box-sizing: border-box;
}

.Feedback-titleWrapper-Vhw99 {
	width: 95%;
	margin: 0 auto;
	padding: 0 15px 0 6px;
	margin-bottom: clamp(30px, 3.8vw, 55px);
	-webkit-box-sizing: border-box;
	        box-sizing: border-box;
}

.Feedback-sectionTitle-LsLNw {
	color: var(--secondary-oscuro);
	font-size: clamp(24px, 2.3vw, 32px);
	font-family: var(--font-family-base);
	font-weight: bold;
	line-height: normal;
	margin: 0;
	padding: 0;
	display: inline-block;
}

.Feedback-highlight-FxNrJ {
	color: var(--primary-color);
}

.Feedback-feedbackContainer-jD58M {
	width: 100%;
	margin: 0 auto;
	-webkit-box-sizing: border-box;
	        box-sizing: border-box;
}

.Feedback-feedbackRow-c6Uls {
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	width: 100%;
	background: transparent;
	padding: 0;
	margin: 0;
	position: relative;
	-webkit-box-sizing: border-box;
	        box-sizing: border-box;
	-webkit-box-align: start;
	    -ms-flex-align: start;
	        align-items: flex-start;
}

.Feedback-feedbackBox-F9wqd {
	background-color: transparent !important;
	border-right: 1px solid var(--primary-color) !important;
	-webkit-box-shadow: none !important;
	        box-shadow: none !important;
	padding: 0 12px;
	-webkit-box-sizing: border-box;
	        box-sizing: border-box;
	text-align: center;
}

.Feedback-feedbackBox-F9wqd:last-child {
	border-right: none !important;
}

.Feedback-iconWrapper-c8bQm {
	width: 100%;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
	min-height: 125px;
	margin-bottom: 12px;
	-webkit-transition: -webkit-transform 0.2s ease;
	transition: -webkit-transform 0.2s ease;
	transition: transform 0.2s ease;
	transition: transform 0.2s ease, -webkit-transform 0.2s ease;
}

@media (min-width: 768px) {
	.Feedback-iconVerificados-qQZHc {
		-webkit-transform: translateX(1.4%);
		    -ms-transform: translateX(1.4%);
		        transform: translateX(1.4%);
	}

	.Feedback-iconPagoQr-kmmeG {
		-webkit-transform: translateX(-4.0%);
		    -ms-transform: translateX(-4.0%);
		        transform: translateX(-4.0%);
	}

	.Feedback-iconPrecioClaro-qyVM0 {
		-webkit-transform: translateX(-5.0%);
		    -ms-transform: translateX(-5.0%);
		        transform: translateX(-5.0%);
	}

	.Feedback-iconSoporte-Vb5St {
		-webkit-transform: translateX(-4.3%);
		    -ms-transform: translateX(-4.3%);
		        transform: translateX(-4.3%);
	}
}

.Feedback-homeIcon-mUylz,
.Feedback-monedaIcon-rzvAP,
.Feedback-celularIcon-gMAWO {
	width: clamp(90px, 8.5vw, 125px);
	height: clamp(90px, 8.5vw, 125px);
	-o-object-fit: contain;
	   object-fit: contain;
	margin: auto;
	display: block;
}

.Feedback-landingLabel-PTclK {
	margin: 0 auto 10px;
	font-size: clamp(18px, 1.6vw, 24px);
	font-weight: 800;
	font-family: var(--font-family-primary);
	color: var(--secondary-esmeralda);
	line-height: 1.25;
	text-align: center;
	display: block;
}

.Feedback-landingCaption-o3neC {
	text-align: center;
	font-size: clamp(14px, 1.25vw, 18px);
	font-weight: 500;
	font-family: var(--font-family-base);
	line-height: 1.45;
	margin: 0 auto;
	color: #000000;
	/* max-width: 250px; */
	display: block;
}

.Feedback-feedbackContent-EmRBz {
	padding: 0;
	text-align: center;
}

.Feedback-flex-idpYW {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	    -ms-flex-direction: column;
	        flex-direction: column;
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	text-align: center;
}

@media (max-width: 991px) and (min-width: 768px) {
	.Feedback-landingCaption-o3neC {
		max-width: 200px;
	}
}

@media screen and (max-width: 767px) {
	.Feedback-root-Zwdi4 {
		background-size: cover;
		padding-top: 45px;
		padding-bottom: 55px;
	}

	.Feedback-feedbackRow-c6Uls {
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-ms-flex-wrap: wrap;
		    flex-wrap: wrap;
		-webkit-box-pack: center;
		    -ms-flex-pack: center;
		        justify-content: center;
		overflow-x: auto;
		-ms-scroll-snap-type: x mandatory;
		    scroll-snap-type: x mandatory;
		-webkit-overflow-scrolling: touch;
		gap: 20px;
		padding: 10px 20px 20px;
	}

	.Feedback-feedbackBox-F9wqd {
		-webkit-box-flex: 0;
		    -ms-flex: 0 0 240px;
		        flex: 0 0 240px;
		scroll-snap-align: center;
		padding: 0;
		border-right: none !important;
	}

	.Feedback-iconWrapper-c8bQm {
		/* background: #E2EEFA; */
		border-radius: 50%;
		width: 130px;
		height: 130px;
		margin: 0 auto 12px;
	}

	.Feedback-homeIcon-mUylz,
	.Feedback-monedaIcon-rzvAP,
	.Feedback-celularIcon-gMAWO {
		width: 95px;
		height: 95px;
	}

	.Feedback-landingCaption-o3neC {
		max-width: none;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/Feedback/Feedback.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC1NA;CACC,gCAAgC;CAChC,YAAY;CACZ,WAAW;CACX,kBAAkB;CAClB,yDAA6E;CAC7E,4BAA4B;CAC5B,+BAA+B;CAC/B,0BAA0B;CAC1B,sCAAsC;CACtC,yCAAyC;CACzC,8BAAsB;SAAtB,sBAAsB;AACvB;;AAEA;CACC,cAAc;CACd,WAAW;CACX,uBAAuB;CACvB,cAAc;CACd,8BAAsB;SAAtB,sBAAsB;AACvB;;AAEA;CACC,UAAU;CACV,cAAc;CACd,qBAAqB;CACrB,uCAAuC;CACvC,8BAAsB;SAAtB,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;CAC9B,mCAAmC;CACnC,oCAAoC;CACpC,iBAAiB;CACjB,mBAAmB;CACnB,SAAS;CACT,UAAU;CACV,qBAAqB;AACtB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,WAAW;CACX,cAAc;CACd,8BAAsB;SAAtB,sBAAsB;AACvB;;AAEA;CACC,aAAa;CACb,qCAAqC;CACrC,WAAW;CACX,uBAAuB;CACvB,UAAU;CACV,SAAS;CACT,kBAAkB;CAClB,8BAAsB;SAAtB,sBAAsB;CACtB,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;AACxB;;AAEA;CACC,wCAAwC;CACxC,uDAAuD;CACvD,mCAA2B;SAA3B,2BAA2B;CAC3B,eAAe;CACf,8BAAsB;SAAtB,sBAAsB;CACtB,kBAAkB;AACnB;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,WAAW;CACX,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;CACvB,iBAAiB;CACjB,mBAAmB;CACnB,+CAA+B;CAA/B,uCAA+B;CAA/B,+BAA+B;CAA/B,4DAA+B;AAChC;;AAEA;CACC;EACC,mCAA2B;MAA3B,+BAA2B;UAA3B,2BAA2B;CAC5B;;CAEA;EACC,oCAA4B;MAA5B,gCAA4B;UAA5B,4BAA4B;CAC7B;;CAEA;EACC,oCAA4B;MAA5B,gCAA4B;UAA5B,4BAA4B;CAC7B;;CAEA;EACC,oCAA4B;MAA5B,gCAA4B;UAA5B,4BAA4B;CAC7B;AACD;;AAEA;;;CAGC,gCAAgC;CAChC,iCAAiC;CACjC,sBAAmB;IAAnB,mBAAmB;CACnB,YAAY;CACZ,cAAc;AACf;;AAEA;CACC,mBAAmB;CACnB,mCAAmC;CACnC,gBAAgB;CAChB,uCAAuC;CACvC,iCAAiC;CACjC,iBAAiB;CACjB,kBAAkB;CAClB,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,oCAAoC;CACpC,gBAAgB;CAChB,oCAAoC;CACpC,iBAAiB;CACjB,cAAc;CACd,cAAc;CACd,sBAAsB;CACtB,cAAc;AACf;;AAEA;CACC,UAAU;CACV,kBAAkB;AACnB;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,4BAAsB;CAAtB,6BAAsB;KAAtB,0BAAsB;SAAtB,sBAAsB;CACtB,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;CACvB,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;CACC;EACC,gBAAgB;CACjB;AACD;;AAEA;CACC;EACC,sBAAsB;EACtB,iBAAiB;EACjB,oBAAoB;CACrB;;CAEA;EACC,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,mBAAe;MAAf,eAAe;EACf,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,gBAAgB;EAChB,iCAA6B;MAA7B,6BAA6B;EAC7B,iCAAiC;EACjC,SAAS;EACT,uBAAuB;CACxB;;CAEA;EACC,mBAAe;MAAf,mBAAe;UAAf,eAAe;EACf,yBAAyB;EACzB,UAAU;EACV,6BAA6B;CAC9B;;CAEA;EACC,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;CACpB;;CAEA;;;EAGC,WAAW;EACX,YAAY;CACb;;CAEA;EACC,eAAe;CAChB;AACD","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}","@import '../helpers.css';\n\n.root {\n\tcolor: var(--primary-foreground);\n\tpadding: 0px;\n\twidth: 100%;\n\tposition: relative;\n\tbackground-image: url('/public/SiteImages/fondo-ondulado-para-personaje.svg');\n\tbackground-repeat: no-repeat;\n\tbackground-position: center top;\n\tbackground-size: 100% 100%;\n\tpadding-top: clamp(60px, 6.5vw, 105px);\n\tpadding-bottom: clamp(65px, 7.5vw, 120px);\n\tbox-sizing: border-box;\n}\n\n.container {\n\tmargin: 0 auto;\n\twidth: 100%;\n\t/* max-width: 1578px; */\n\tdisplay: block;\n\tbox-sizing: border-box;\n}\n\n.titleWrapper {\n\twidth: 95%;\n\tmargin: 0 auto;\n\tpadding: 0 15px 0 6px;\n\tmargin-bottom: clamp(30px, 3.8vw, 55px);\n\tbox-sizing: border-box;\n}\n\n.sectionTitle {\n\tcolor: var(--secondary-oscuro);\n\tfont-size: clamp(24px, 2.3vw, 32px);\n\tfont-family: var(--font-family-base);\n\tfont-weight: bold;\n\tline-height: normal;\n\tmargin: 0;\n\tpadding: 0;\n\tdisplay: inline-block;\n}\n\n.highlight {\n\tcolor: var(--primary-color);\n}\n\n.feedbackContainer {\n\twidth: 100%;\n\tmargin: 0 auto;\n\tbox-sizing: border-box;\n}\n\n.feedbackRow {\n\tdisplay: grid;\n\tgrid-template-columns: repeat(4, 1fr);\n\twidth: 100%;\n\tbackground: transparent;\n\tpadding: 0;\n\tmargin: 0;\n\tposition: relative;\n\tbox-sizing: border-box;\n\talign-items: flex-start;\n}\n\n.feedbackBox {\n\tbackground-color: transparent !important;\n\tborder-right: 1px solid var(--primary-color) !important;\n\tbox-shadow: none !important;\n\tpadding: 0 12px;\n\tbox-sizing: border-box;\n\ttext-align: center;\n}\n\n.feedbackBox:last-child {\n\tborder-right: none !important;\n}\n\n.iconWrapper {\n\twidth: 100%;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tmin-height: 125px;\n\tmargin-bottom: 12px;\n\ttransition: transform 0.2s ease;\n}\n\n@media (min-width: 768px) {\n\t.iconVerificados {\n\t\ttransform: translateX(1.4%);\n\t}\n\n\t.iconPagoQr {\n\t\ttransform: translateX(-4.0%);\n\t}\n\n\t.iconPrecioClaro {\n\t\ttransform: translateX(-5.0%);\n\t}\n\n\t.iconSoporte {\n\t\ttransform: translateX(-4.3%);\n\t}\n}\n\n.homeIcon,\n.monedaIcon,\n.celularIcon {\n\twidth: clamp(90px, 8.5vw, 125px);\n\theight: clamp(90px, 8.5vw, 125px);\n\tobject-fit: contain;\n\tmargin: auto;\n\tdisplay: block;\n}\n\n.landingLabel {\n\tmargin: 0 auto 10px;\n\tfont-size: clamp(18px, 1.6vw, 24px);\n\tfont-weight: 800;\n\tfont-family: var(--font-family-primary);\n\tcolor: var(--secondary-esmeralda);\n\tline-height: 1.25;\n\ttext-align: center;\n\tdisplay: block;\n}\n\n.landingCaption {\n\ttext-align: center;\n\tfont-size: clamp(14px, 1.25vw, 18px);\n\tfont-weight: 500;\n\tfont-family: var(--font-family-base);\n\tline-height: 1.45;\n\tmargin: 0 auto;\n\tcolor: #000000;\n\t/* max-width: 250px; */\n\tdisplay: block;\n}\n\n.feedbackContent {\n\tpadding: 0;\n\ttext-align: center;\n}\n\n.flex {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: center;\n\ttext-align: center;\n}\n\n@media (max-width: 991px) and (min-width: 768px) {\n\t.landingCaption {\n\t\tmax-width: 200px;\n\t}\n}\n\n@media screen and (max-width: 767px) {\n\t.root {\n\t\tbackground-size: cover;\n\t\tpadding-top: 45px;\n\t\tpadding-bottom: 55px;\n\t}\n\n\t.feedbackRow {\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n\t\tjustify-content: center;\n\t\toverflow-x: auto;\n\t\tscroll-snap-type: x mandatory;\n\t\t-webkit-overflow-scrolling: touch;\n\t\tgap: 20px;\n\t\tpadding: 10px 20px 20px;\n\t}\n\n\t.feedbackBox {\n\t\tflex: 0 0 240px;\n\t\tscroll-snap-align: center;\n\t\tpadding: 0;\n\t\tborder-right: none !important;\n\t}\n\n\t.iconWrapper {\n\t\t/* background: #E2EEFA; */\n\t\tborder-radius: 50%;\n\t\twidth: 130px;\n\t\theight: 130px;\n\t\tmargin: 0 auto 12px;\n\t}\n\n\t.homeIcon,\n\t.monedaIcon,\n\t.celularIcon {\n\t\twidth: 95px;\n\t\theight: 95px;\n\t}\n\n\t.landingCaption {\n\t\tmax-width: none;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `Feedback-space1-X4QlB`,
	"space2": `Feedback-space2-ikHfX`,
	"space3": `Feedback-space3-R4nNe`,
	"space4": `Feedback-space4-RqXTZ`,
	"space5": `Feedback-space5-mWZay`,
	"space6": `Feedback-space6-iDXQD`,
	"space7": `Feedback-space7-CPYYl`,
	"spaceTop8": `Feedback-spaceTop8-GuA_r`,
	"spaceTop1": `Feedback-spaceTop1-bdpfn`,
	"spaceTop2": `Feedback-spaceTop2-laFS0`,
	"spaceTop3": `Feedback-spaceTop3-nQL5U`,
	"spaceTop4": `Feedback-spaceTop4-MNUWU`,
	"spaceTop5": `Feedback-spaceTop5-qY4ZT`,
	"spaceTop6": `Feedback-spaceTop6-MJ8AC`,
	"spaceTop7": `Feedback-spaceTop7-it3S1`,
	"noMargin": `Feedback-noMargin-A5N02`,
	"padding1": `Feedback-padding1-_CZfk`,
	"padding2": `Feedback-padding2-pzcs7`,
	"padding3": `Feedback-padding3-cgY4R`,
	"padding4": `Feedback-padding4-AdLns`,
	"padding5": `Feedback-padding5-SoG33`,
	"padding6": `Feedback-padding6-uuRob`,
	"padding7": `Feedback-padding7-SoGNE`,
	"paddingTop1": `Feedback-paddingTop1-Qj0sU`,
	"paddingTop2": `Feedback-paddingTop2-tz6OJ`,
	"paddingTop3": `Feedback-paddingTop3-oljW9`,
	"paddingTop4": `Feedback-paddingTop4-OHoVp`,
	"paddingTop5": `Feedback-paddingTop5-pgb3N`,
	"paddingTop6": `Feedback-paddingTop6-j3xYT`,
	"paddingTop7": `Feedback-paddingTop7-JQ3X9`,
	"noPadding": `Feedback-noPadding-EbPH9`,
	"textBold": `Feedback-textBold-q1H4F`,
	"textBolder": `Feedback-textBolder-sa70W`,
	"textNormal": `Feedback-textNormal-Ee5A5`,
	"spaceBottom20": `Feedback-spaceBottom20-dS0Pv`,
	"spaceBottom10": `Feedback-spaceBottom10-VwjvL`,
	"marginNone": `Feedback-marginNone-Xh6Gb`,
	"spaceBottom15": `Feedback-spaceBottom15-hJ2qE`,
	"marginTopNone": `Feedback-marginTopNone-rSvqD`,
	"spaceTop11": `Feedback-spaceTop11-N0t_r`,
	"spaceTop21": `Feedback-spaceTop21-lJRtS`,
	"spaceTop20": `Feedback-spaceTop20-E51Q1`,
	"spaceTop10": `Feedback-spaceTop10-YUUC9`,
	"textDarkBlue": `Feedback-textDarkBlue-hodQA`,
	"textLightBlue": `Feedback-textLightBlue-F_1Z3`,
	"textLightSandleGreen": `Feedback-textLightSandleGreen-ChU2A`,
	"textLightBrown": `Feedback-textLightBrown-M32ww`,
	"textMediumMaroon": `Feedback-textMediumMaroon-Z0nQN`,
	"textBrown": `Feedback-textBrown-WQghJ`,
	"textMaroon": `Feedback-textMaroon-k8lGw`,
	"textDarkBrown": `Feedback-textDarkBrown-tlbV2`,
	"textMediumBrown": `Feedback-textMediumBrown-vKSc4`,
	"textSkyBlue": `Feedback-textSkyBlue-l7Zb8`,
	"textGray": `Feedback-textGray-CDalt`,
	"root": `Feedback-root-Zwdi4`,
	"container": `Feedback-container-ynCq4`,
	"titleWrapper": `Feedback-titleWrapper-Vhw99`,
	"sectionTitle": `Feedback-sectionTitle-LsLNw`,
	"highlight": `Feedback-highlight-FxNrJ`,
	"feedbackContainer": `Feedback-feedbackContainer-jD58M`,
	"feedbackRow": `Feedback-feedbackRow-c6Uls`,
	"feedbackBox": `Feedback-feedbackBox-F9wqd`,
	"iconWrapper": `Feedback-iconWrapper-c8bQm`,
	"iconVerificados": `Feedback-iconVerificados-qQZHc`,
	"iconPagoQr": `Feedback-iconPagoQr-kmmeG`,
	"iconPrecioClaro": `Feedback-iconPrecioClaro-qyVM0`,
	"iconSoporte": `Feedback-iconSoporte-Vb5St`,
	"homeIcon": `Feedback-homeIcon-mUylz`,
	"monedaIcon": `Feedback-monedaIcon-rzvAP`,
	"celularIcon": `Feedback-celularIcon-gMAWO`,
	"landingLabel": `Feedback-landingLabel-PTclK`,
	"landingCaption": `Feedback-landingCaption-o3neC`,
	"feedbackContent": `Feedback-feedbackContent-EmRBz`,
	"flex": `Feedback-flex-idpYW`
};
module.exports = ___CSS_LOADER_EXPORT___;
